import BasicClaimInfoForm from "./BasicClaimInfoForm";

export default BasicClaimInfoForm;
